import React, { useState, useContext } from "react";
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  textField: {
    width: '100%',
  },
}))

export const FullWidthTextField = (props) => {
  const classes = useStyles();
  return <TextField className={classes.textField} {...props}></TextField>
}